import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
/**
 * A titled region of a screen, and the one place the heading level is decided.
 *
 * The level is `h2` unless a screen says otherwise. Every product screen sits
 * inside the shell, which owns the page's `h1`, so a section of a screen is one
 * level below it; `level` exists for the screens with no shell heading above
 * them (the administration's) and for a section nested in another. That
 * default was not true when each screen wrote its own heading: the same
 * role appeared as `h2` on the dashboard, the students list and the student
 * home, and as `h3` on the practice, student and practices screens — identical
 * on screen, and a different document outline underneath. Heading navigation
 * is how a screen-reader user skims a page, so that difference was invisible
 * to everyone except the people who depend on it.
 *
 * Sizing is fixed for the same reason. `text-h3` at `h2` looks like an
 * inconsistency and is not one: the type scale and the outline are separate
 * systems, and a section heading is the third size down while being the second
 * level down.
 */
export function Section({ id, title, children, aside, level = 2, variant = 'plain', className, }) {
    const Heading = `h${level}`;
    return (_jsxs("section", { className: cn('flex flex-col gap-4', className), "aria-labelledby": id, children: [_jsxs("div", { className: cn('flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1', variant === 'ruled' && 'border-b border-border pb-3'), children: [_jsx(Heading, { id: id, ...(level === 1 ? { tabIndex: -1 } : {}), className: "text-h3 font-semibold text-text outline-none", children: title }), aside] }), children] }));
}
//# sourceMappingURL=Section.js.map